import { render, staticRenderFns } from "./WebCallDeliveryDialog.vue?vue&type=template&id=7b8d775a&"
import script from "./WebCallDeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./WebCallDeliveryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports